import axios from "axios";
import CONFIG from "../config/config";

const httpClientWithoutToken = axios.create({
  baseURL: CONFIG.BASE_API_URL,
  headers: {
    "Content-Type": "application/json",
    "Access-Control-Allow-Origin": "*"
  }
});

export default httpClientWithoutToken;
